import type { LicenseSettingChange } from '@store/api/activationLogEndpoints';

const NAMES: Record<LicenseSettingChange['field'], string> = {
  offlineCreditAdminWindowSeconds: 'Offline credit window',
  offlineCreditAdminBudgetSeconds: 'Offline credit budget',
  seatAllocationAdminTimeInSeconds: 'Seat time'
};

/** A value as the Licenses page writes it; for offline credit, zero means none. */
const amount = (change: LicenseSettingChange, seconds: number | null) => {
  if (seconds === null) return '-';
  if (seconds === 0 && change.field !== 'seatAllocationAdminTimeInSeconds') return '0 (no offline credit)';

  return seconds.formatDuration();
};

/**
 * One value an administrator changed, as the Activity page writes it: set, changed or cleared, from
 * what to what, and whether devices now get the administrator's value or the license file's.
 *
 *   Seat time set to 8 h, in place of the license file's 15 min
 *   Seat time changed from 8 h to 4 h
 *   Seat time cleared from 4 h, back to the license file's 15 min
 */
export const describeLicenseSettingChange = (change: LicenseSettingChange) => {
  const name = NAMES[change.field] ?? change.field;

  if (change.to === null) {
    return `${name} cleared from ${amount(change, change.from)}, back to the license file's ${amount(change, change.effective)}`;
  }

  if (change.from === null) {
    return change.licenseFile === null
      ? `${name} set to ${amount(change, change.to)}`
      : `${name} set to ${amount(change, change.to)}, in place of the license file's ${amount(change, change.licenseFile)}`;
  }

  return `${name} changed from ${amount(change, change.from)} to ${amount(change, change.to)}`;
};
